import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyChooseMe } from './components/WhyChooseMe';
import { Portfolio } from './components/Portfolio';
import { Testimonials } from './components/Testimonials';
import { Process } from './components/Process';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  return <div className="min-h-screen bg-black text-slate-300 selection:bg-blue-500/30" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <WhyChooseMe data-id="element-6" />
        <Portfolio data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Process data-id="element-9" />
        <Pricing data-id="element-10" />
        <FAQ data-id="element-11" />
        <Contact data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}